export interface EventScheduleItem {
  time: string;
  title: string;
  desc: string;
}

export interface EventDetail {
  id: number;
  slug: string;
  title: string;
  subtitle: string;
  category: string;
  categoryColor: string;
  date: string;
  endDate?: string;
  location: string;
  locationMapUrl: string;
  price: number;
  priceLabel: string;
  spotsLeft: number;
  totalSpots: number;
  heroImage: string;
  galleryImages: string[];
  description: string;
  highlights: string[];
  targetAudience: string[];
  includes: string[];
  schedule: EventScheduleItem[];
  tags: string[];
  organizer: string;
  contactLine: string;
}

export const eventDetails: EventDetail[] = [
  {
    id: 1,
    slug: "glamping-party",
    title: "微醺山林露營派對",
    subtitle: "星空、炭火與你的故事",
    category: "戶外冒險",
    categoryColor: "bg-orange-600",
    date: "2026/04/25",
    endDate: "2026/04/26",
    location: "南投縣仁愛鄉私房營地",
    locationMapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d115756.23!2d121.0!3d23.9!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x346efa!2z5Y-w5oqA!5e0!3m2!1szh-TW!2stw!4v1",
    price: 2800,
    priceLabel: "NT$ 2,800 / 人",
    spotsLeft: 8,
    totalSpots: 30,
    heroImage: "https://public.readdy.ai/ai/img_res/31a25ecd0242f8c419dce9d5cfe81812.jpg",
    galleryImages: [
      "https://readdy.ai/api/search-image?query=luxury%20glamping%20tent%20interior%20with%20cozy%20bedding%2C%20warm%20fairy%20lights%2C%20wooden%20furniture%2C%20romantic%20camping%20atmosphere%2C%20Taiwan%20mountain%20forest&width=600&height=400&seq=gal001&orientation=landscape",
      "https://readdy.ai/api/search-image?query=professional%20chef%20grilling%20premium%20meat%20at%20outdoor%20barbecue%2C%20charcoal%20fire%2C%20delicious%20food%2C%20camping%20feast%2C%20Taiwan%20outdoor%20event&width=600&height=400&seq=gal002&orientation=landscape",
      "https://readdy.ai/api/search-image?query=group%20of%20young%20adults%20laughing%20around%20campfire%20at%20night%2C%20warm%20orange%20glow%2C%20starry%20sky%2C%20genuine%20joy%2C%20Taiwan%20camping%20social%20event&width=600&height=400&seq=gal003&orientation=landscape",
      "https://readdy.ai/api/search-image?query=outdoor%20movie%20screening%20under%20stars%2C%20projector%20screen%20in%20forest%2C%20people%20sitting%20on%20blankets%2C%20cozy%20night%20atmosphere%2C%20Taiwan%20glamping&width=600&height=400&seq=gal004&orientation=landscape",
    ],
    description: "別再羨慕螢幕裡的星空。加入我們的露營計畫，讓炭火的餘溫與清晨的露水，洗去城市的喧囂。\n\n「微醺山林露營派對」是紅歡密最受歡迎的旗艦活動。我們精選南投仁愛鄉私房營地，遠離都市喧囂，讓你在山嵐美景中徹底放鬆。不需要自備任何裝備，只需帶上放鬆的心，我們為你準備好一切。\n\n從職人級烤肉饗宴到星空電影院，從自然系破冰遊戲到微醺特調飲品，每一個環節都經過紅歡密團隊反覆推敲，只為讓你擁有一段真正難忘的山林時光。",
    highlights: [
      "私房營地體驗：精選具備山嵐美景的私房營地，遠離都市喧囂",
      "職人級烤肉饗宴：由紅歡密團隊操刀，提供頂級食材與現烤美味",
      "自然系破冰遊戲：趣味團隊小比賽，讓好感在歡笑中自然萌芽",
      "微醺星空電影院：入夜後在星空下品嚐特調飲品，享受大銀幕震撼",
      "免裝備全包服務：帳篷、床墊、寢具、餐具全部備妥",
    ],
    targetAudience: [
      "熱愛戶外生活、想認識新朋友的你",
      "想逃離城市壓力、徹底放空的靈魂",
      "情侶、閨蜜、好友小團體",
      "第一次露營的新手（完全不需要經驗！）",
    ],
    includes: [
      "一泊三食（晚餐烤肉 + 宵夜 + 早餐）",
      "全套露營裝備（帳篷、床墊、寢具）",
      "星空電影院入場",
      "特調微醺飲品一份",
      "活動保險",
      "紅歡密專屬驚喜小禮",
    ],
    schedule: [
      { time: "14:00", title: "入場報到", desc: "抵達營地，完成報到手續，認識今天的夥伴們" },
      { time: "15:00", title: "自然系破冰遊戲", desc: "趣味團隊競賽，打破陌生感，讓好感自然萌芽" },
      { time: "17:30", title: "職人烤肉饗宴", desc: "職人主廚現場操刀，頂級食材、炭火香氣，邊烤邊聊" },
      { time: "20:00", title: "微醺星空電影院", desc: "在星空下品嚐特調飲品，享受大銀幕的感官震撼" },
      { time: "22:30", title: "營火夜話", desc: "圍著營火，分享彼此的故事，感受最真實的連結" },
      { time: "隔日 07:00", title: "森林晨間瑜珈", desc: "在清晨薄霧中舒展身體，感受大自然的療癒能量" },
      { time: "隔日 08:30", title: "豐盛早餐", desc: "現做早餐，配上山林清新空氣，完美收尾" },
      { time: "隔日 11:00", title: "拔營賦歸", desc: "帶著滿滿回憶，期待下一次的紅歡密時刻" },
    ],
    tags: ["露營", "烤肉", "星空電影", "破冰遊戲", "戶外冒險"],
    organizer: "娛樂紅歡密",
    contactLine: "https://lin.ee/wpeGAKJ",
  },
  {
    id: 2,
    slug: "book-club",
    title: "靈魂交換讀書會",
    subtitle: "不只是閱讀，是一場知性派對",
    category: "知性學習",
    categoryColor: "bg-emerald-700",
    date: "2026/05/03",
    location: "台中市西區質感書房",
    locationMapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3640.5!2d120.67!3d24.15!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x34693!2z5Y-w5Lit!5e0!3m2!1szh-TW!2stw!4v1",
    price: 680,
    priceLabel: "NT$ 680 / 人",
    spotsLeft: 5,
    totalSpots: 20,
    heroImage: "https://readdy.ai/api/search-image?query=cozy%20book%20club%20gathering%20in%20warm%20lit%20cafe%2C%20people%20reading%20and%20discussing%20books%2C%20tea%20cups%20on%20wooden%20table%2C%20soft%20warm%20lighting%2C%20intellectual%20atmosphere%2C%20Taiwan%20lifestyle%20photography&width=1400&height=700&seq=det002&orientation=landscape",
    galleryImages: [
      "https://readdy.ai/api/search-image?query=people%20engaged%20in%20deep%20intellectual%20discussion%20at%20book%20club%2C%20warm%20cafe%20setting%2C%20books%20and%20notes%20on%20table%2C%20Taiwan%20lifestyle&width=600&height=400&seq=gal005&orientation=landscape",
      "https://readdy.ai/api/search-image?query=handmade%20desserts%20and%20tea%20on%20wooden%20table%2C%20cozy%20cafe%20atmosphere%2C%20book%20club%20snacks%2C%20warm%20lighting%2C%20Taiwan&width=600&height=400&seq=gal006&orientation=landscape",
      "https://readdy.ai/api/search-image?query=small%20group%20discussion%20at%20round%20table%2C%20diverse%20young%20adults%20sharing%20ideas%2C%20warm%20indoor%20lighting%2C%20intellectual%20gathering%20Taiwan&width=600&height=400&seq=gal007&orientation=landscape",
      "https://readdy.ai/api/search-image?query=speaker%20presenting%20at%20intimate%20book%20club%20event%2C%20engaged%20audience%2C%20cozy%20venue%2C%20warm%20lighting%2C%20Taiwan%20cultural%20event&width=600&height=400&seq=gal008&orientation=landscape",
    ],
    description: "你是否也曾買了一堆書卻沒時間看？或者看完後滿腔心得卻找不到人分享？\n\n「娛樂紅歡密」打破傳統枯燥的導讀模式，將讀書會轉化為一場沈浸式的知性派對。我們不只是讀書，更是在交換彼此的生命視角。\n\n每一場讀書會都有精心挑選的主題書目，搭配跨界職人導讀，讓書本知識不再只是紙上談兵。在深度共感時間裡，你將聽見不同的生命故事，遇見更有趣的靈魂。",
    highlights: [
      "非典型主題：從商業思維、心理成長到奇幻文學，每場都是新冒險",
      "跨界導讀：邀請不同領域職人分享實戰經驗",
      "深度共感時間：專屬 Q&A 與小組討論，擴張思維邊界",
      "手作輕食：配上好茶與手作甜點，讓大腦與味蕾同時得到慰藉",
      "社群連結：加入紅歡密讀書會專屬社群，持續交流",
    ],
    targetAudience: [
      "想跳出同溫層、熱愛學習的你",
      "看完書找不到人分享的靈魂",
      "想提升溝通與表達能力的職場人",
      "喜歡認識有深度朋友的斜槓青年",
    ],
    includes: [
      "精選書目導讀講義",
      "質感輕食組（手作甜點 + 精選茶飲）",
      "小組討論引導",
      "紅歡密讀書會社群連結",
      "活動紀念書籤",
    ],
    schedule: [
      { time: "13:30", title: "入場報到 & 輕食時間", desc: "享用手作甜點與茶飲，與旁邊的夥伴自然開啟對話" },
      { time: "14:00", title: "破冰暖身", desc: "輕鬆的小活動，讓大家快速進入狀態" },
      { time: "14:20", title: "核心選書分享", desc: "本期主題書目精華導讀，由跨界職人帶領深入解析" },
      { time: "15:10", title: "異觀點對談", desc: "分組討論，每組分享不同視角，激盪思維火花" },
      { time: "15:50", title: "Q&A 深度交流", desc: "向講師提問，聽見更多生命故事" },
      { time: "16:20", title: "自由交流時間", desc: "交換聯絡方式，延續今天的精彩對話" },
      { time: "17:00", title: "活動結束", desc: "帶著新的視角與新的朋友，期待下次相遇" },
    ],
    tags: ["讀書會", "深度對談", "輕食", "知性學習", "社交"],
    organizer: "娛樂紅歡密",
    contactLine: "https://lin.ee/wpeGAKJ",
  },
  {
    id: 3,
    slug: "social-game",
    title: "紅歡密聯誼賽",
    subtitle: "拒絕死板排排坐！趣味競賽找默契",
    category: "社交聯誼",
    categoryColor: "bg-rose-600",
    date: "2026/05/10",
    location: "台中市北區活動中心",
    locationMapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3640.5!2d120.68!3d24.16!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x34693!2z5Y-w5Lit!5e0!3m2!1szh-TW!2stw!4v1",
    price: 580,
    priceLabel: "NT$ 580 / 人",
    spotsLeft: 15,
    totalSpots: 50,
    heroImage: "https://readdy.ai/api/search-image?query=fun%20social%20gathering%20event%20with%20young%20adults%20playing%20games%2C%20laughing%20and%20interacting%2C%20colorful%20indoor%20venue%2C%20warm%20lighting%2C%20Taiwan%20social%20event%20photography%2C%20energetic%20atmosphere&width=1400&height=700&seq=det003&orientation=landscape",
    galleryImages: [
      "https://readdy.ai/api/search-image?query=young%20adults%20playing%20fun%20team%20games%20at%20social%20event%2C%20laughing%20and%20competing%2C%20colorful%20venue%2C%20Taiwan%20social%20mixer&width=600&height=400&seq=gal009&orientation=landscape",
      "https://readdy.ai/api/search-image?query=ice%20breaker%20games%20at%20social%20event%2C%20people%20interacting%20and%20smiling%2C%20indoor%20venue%20with%20warm%20lighting%2C%20Taiwan%20young%20adults&width=600&height=400&seq=gal010&orientation=landscape",
      "https://readdy.ai/api/search-image?query=couples%20and%20friends%20at%20social%20mixer%20event%2C%20natural%20interactions%2C%20warm%20atmosphere%2C%20Taiwan%20dating%20event&width=600&height=400&seq=gal011&orientation=landscape",
      "https://readdy.ai/api/search-image?query=award%20ceremony%20at%20fun%20social%20event%2C%20cheering%20crowd%2C%20colorful%20decorations%2C%20Taiwan%20entertainment%20event&width=600&height=400&seq=gal012&orientation=landscape",
    ],
    description: "跳過傳統尷尬的面對面。在紅歡密的趣味遊戲與競賽中，讓好感在歡笑中自然發生。\n\n「紅歡密聯誼賽」徹底顛覆你對聯誼的想像！我們拒絕死板的排排坐自我介紹，取而代之的是一系列精心設計的趣味競賽與破冰遊戲。\n\n透過實境闖關、默契測試、趣味競技，你將在不知不覺中認識到最有緣分的那個人。紅歡密相信，最自然的相遇，發生在最真實的歡笑裡。",
    highlights: [
      "趣味競賽設計：多關卡實境闖關，讓互動自然發生",
      "默契配對遊戲：科學設計的配對機制，找到最有默契的夥伴",
      "破冰小遊戲：告別尷尬，讓歡笑成為最好的開場白",
      "頒獎典禮：最佳默契獎、最佳笑容獎等趣味獎項",
      "交流時間：活動後的自由交流，讓緣分繼續延伸",
    ],
    targetAudience: [
      "單身、想認識新朋友的你",
      "討厭傳統聯誼形式的人",
      "喜歡遊戲競賽、充滿活力的靈魂",
      "想在輕鬆氛圍中自然認識人的你",
    ],
    includes: [
      "全程活動參與",
      "輕食茶點",
      "趣味獎品",
      "活動紀念照",
      "紅歡密社群連結",
    ],
    schedule: [
      { time: "18:30", title: "入場報到 & 暖身", desc: "領取號碼牌，享用輕食，與旁邊的人打個招呼" },
      { time: "19:00", title: "開場介紹 & 規則說明", desc: "主持人帶領大家了解今晚的遊戲規則" },
      { time: "19:15", title: "第一關：破冰任務", desc: "在限時內完成指定任務，認識最多新朋友" },
      { time: "19:45", title: "第二關：默契大考驗", desc: "隨機配對，測試你們的心靈感應" },
      { time: "20:15", title: "第三關：實境闖關", desc: "分組競賽，在挑戰中展現你的魅力" },
      { time: "20:50", title: "頒獎典禮", desc: "各項趣味獎項頒發，笑聲不斷" },
      { time: "21:10", title: "自由交流時間", desc: "交換聯絡方式，讓今晚的緣分繼續" },
      { time: "22:00", title: "活動結束", desc: "帶著新朋友的聯絡方式，期待下次相遇" },
    ],
    tags: ["聯誼", "趣味競賽", "破冰遊戲", "社交", "單身"],
    organizer: "娛樂紅歡密",
    contactLine: "https://lin.ee/wpeGAKJ",
  },
  {
    id: 4,
    slug: "family-camp",
    title: "小小營火官親子營",
    subtitle: "昆蟲觀察、手作DIY、星空下的故事會",
    category: "親子時光",
    categoryColor: "bg-amber-600",
    date: "2026/05/17",
    endDate: "2026/05/18",
    location: "台中市和平區森林基地",
    locationMapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3640.5!2d120.9!3d24.3!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x34693!2z5Y-w5Lit!5e0!3m2!1szh-TW!2stw!4v1",
    price: 3200,
    priceLabel: "NT$ 3,200 / 組（大人+小孩）",
    spotsLeft: 10,
    totalSpots: 25,
    heroImage: "https://readdy.ai/api/search-image?query=family%20camping%20with%20children%20in%20forest%2C%20parents%20and%20kids%20around%20campfire%2C%20daytime%20outdoor%20activities%2C%20nature%20exploration%2C%20warm%20sunlight%20through%20trees%2C%20Taiwan%20family%20outdoor%20event&width=1400&height=700&seq=det004&orientation=landscape",
    galleryImages: [
      "https://readdy.ai/api/search-image?query=children%20doing%20DIY%20craft%20activities%20outdoors%2C%20colorful%20handmade%20crafts%2C%20happy%20kids%2C%20nature%20background%2C%20Taiwan%20family%20event&width=600&height=400&seq=gal013&orientation=landscape",
      "https://readdy.ai/api/search-image?query=family%20insect%20observation%20in%20forest%2C%20children%20with%20magnifying%20glass%2C%20parents%20guiding%2C%20nature%20education%2C%20Taiwan%20outdoor&width=600&height=400&seq=gal014&orientation=landscape",
      "https://readdy.ai/api/search-image?query=parents%20and%20children%20around%20campfire%20at%20night%2C%20storytelling%2C%20warm%20glow%2C%20happy%20family%20moments%2C%20Taiwan%20camping&width=600&height=400&seq=gal015&orientation=landscape",
      "https://readdy.ai/api/search-image?query=family%20breakfast%20outdoors%20in%20forest%2C%20picnic%20table%2C%20morning%20light%2C%20happy%20family%2C%20Taiwan%20nature%20camping&width=600&height=400&seq=gal016&orientation=landscape",
    ],
    description: "給孩子一個沒有螢幕的週末，給自己一段與孩子真正在一起的時光。\n\n「小小營火官親子營」專為家庭設計，讓大人與孩子一起走入自然，在昆蟲觀察、手作DIY、星空故事會中，創造一段只屬於你們的珍貴回憶。\n\n我們相信，最好的親子教育，不在課本裡，而在大自然的每一個角落。讓孩子在泥土的氣息中學習，在營火的溫暖中成長。",
    highlights: [
      "昆蟲觀察課：專業自然導師帶領，認識台灣本土昆蟲生態",
      "手作DIY工坊：製作專屬的自然風手工藝品，帶回家的美好紀念",
      "星空故事會：在星空下聽故事、說故事，培養孩子的想像力",
      "親子烤肉：一起動手烤肉，在炭火旁分享今天的冒險",
      "自然探索任務：設計給孩子的闖關任務，在遊戲中學習",
    ],
    targetAudience: [
      "想與孩子共度高品質時光的父母",
      "希望孩子親近自然的家庭",
      "同濟會、家長會等親子團體",
      "孩子年齡建議：4-12 歲",
    ],
    includes: [
      "一泊三食（全家大小）",
      "全套露營裝備",
      "昆蟲觀察課程材料",
      "手作DIY材料包",
      "自然探索任務手冊",
      "活動保險（大人+小孩）",
      "紅歡密專屬親子紀念禮",
    ],
    schedule: [
      { time: "09:00", title: "入場報到 & 認識新朋友", desc: "孩子們互相認識，大人們交流育兒心得" },
      { time: "09:30", title: "自然探索任務出發", desc: "帶著任務手冊，在森林裡尋找自然的秘密" },
      { time: "11:00", title: "昆蟲觀察課", desc: "專業導師帶領，近距離認識台灣本土昆蟲" },
      { time: "12:00", title: "親子午餐", desc: "一起享用豐盛午餐，補充下午的冒險能量" },
      { time: "13:30", title: "手作DIY工坊", desc: "製作專屬的自然風手工藝品，帶回家的美好紀念" },
      { time: "15:30", title: "自由探索時間", desc: "孩子們自由玩耍，大人們放鬆交流" },
      { time: "17:30", title: "親子烤肉饗宴", desc: "一起動手烤肉，在炭火旁分享今天的冒險故事" },
      { time: "20:00", title: "星空故事會", desc: "在星空下聽故事、說故事，培養孩子的想像力" },
      { time: "隔日 07:30", title: "晨間自然散步", desc: "在清晨薄霧中感受森林的寧靜與美好" },
      { time: "隔日 08:30", title: "豐盛早餐 & 拔營", desc: "享用早餐，整理行李，帶著滿滿回憶回家" },
    ],
    tags: ["親子", "自然探索", "手作DIY", "露營", "家庭"],
    organizer: "娛樂紅歡密",
    contactLine: "https://lin.ee/wpeGAKJ",
  },
];
